import { fontSizes, colors } from '../../../../Components/consts'
import { styled } from '@mui/system'

type SideProps = {
  side: string
}

export const StatHeaderStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
}))

export const SideCon = styled('div')<SideProps>(({ side, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: side === 'left' ? 'flex-start' : 'flex-end',
}))

export const TeamImg = styled('img')(({ theme }) => ({
  height: 80,
  margin: theme.spacing(0, 1, 1, 0),
  [theme.breakpoints.down('sm')]: {
    height: 40,
  },
}))

export const InfoStyle = styled('div')<SideProps>(({ side, theme }) => ({
  display: 'block',
  textAlign: side === 'left' ? 'left' : 'right',
  margin: theme.spacing(0, 1),
  '& h2': {
    fontWeight: 700,
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },
  '& p': {
    fontWeight: 500,
    fontSize: fontSizes.medium,
    color: colors.white,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      marginTop: 0,
    },
  },
}))

export const StatRowStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  margin: theme.spacing(1, 0),
}))

type StatColProps = {
  order: number
}
export const StatCol = styled('div')<StatColProps>(({ order, theme }) => ({
  width: order === 2 ? '30%' : '60%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: order === 1 ? 'flex-end' : order === 2 ? 'center' : 'flex-start',
  marginRight: order === 1 ? theme.spacing(2) : 0,
  marginLeft: order === 3 ? theme.spacing(2) : 0,
  [theme.breakpoints.down('sm')]: {
    width: order === 2 ? '35%' : '35%',
  },
  '& .statItem': {
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.medium,
    },
  },
  '& .statText': {
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
}))

export const TStatsHead = styled('h2')(({ theme }) => ({
  textAlign: 'center',
    color: colors.white,
}))